<template>
  <v-container fluid>
    <div>Reports history</div>
    <v-data-table :headers="headers" :items="data" item-key="name" class="elevation-1" disable-pagination>
      <template v-slot:item.created_at="{ item }">
        {{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn small class="ma-2" @click="downloadFile(item.id, item.file)">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn small class="ma-2" @click="deleteReport(item.id)">
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.progress="{ item }">
        {{ item.progress }}%
      </template>"

    </v-data-table>
    
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Reports",
  components: {},
  data() {
    return {
      reports: []
    }
  },
  created() {

  },
  mounted() {
    this.fetchReports();
  },
  computed: {
    headers() {
      return [
        { text: 'Created', value: 'created_at' },
        { text: 'Progress', value: 'progress' },
        { text: 'Status', value: 'status' },
        { text: 'File', value: 'file' },
        { text: 'Actions', value: 'actions', sortable: false }
      ];
    },
    data() {
      return this.reports;
    }
  },
  methods: {
    fetchReports() {
      axios.get('/api/amr/reports_list', {
        headers: {
          authorization: `Token ${localStorage.getItem('token')}`
        }
      })
        .then(response => {
          this.reports = response.data;
          console.log("Fetched reports:", this.reports);
        })
        .catch(error => {
          console.error("Error fetching reports:", error);
        });
    },
    moment(date) {
      return moment(date);
    },
    async downloadFile(id, name) {
      const fileUrl = `/api/amr/reports/download/${id}`;

      try {
        const response = await axios.get(fileUrl, {
          responseType: 'blob', // very important!
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        });

        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', name.split('/').pop()); // set desired filename
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl); // cleanup
      } catch (error) {
        console.error('Download failed:', error);
      }
    },
    deleteReport(id) {
      axios.delete(`/api/amr/reports_list/${id}`, {
        headers: {
          authorization: `Token ${localStorage.getItem('token')}`
        }
      })
        .then(() => {
          this.fetchReports();
        })
        .catch(error => {
          console.error("Error deleting report:", error);
        });
    }
  }
}
</script>

<style></style>
